import React from "react";
import SearchWidgetTabs from "../searchwidgetTabs/searchWidgetTabs";
import DateTime from "src/utils/temporalLuxonUtil";
import { ApplicationContext } from "src/context";
import Icon from "src/components/icon";
import CTAButton from "src/components/ctabutton";
import { DatePickerV2 } from "src/components/datePicker";
import GuestPickerV2 from "src/components/guestPicker.v2";
import { toFormat, toYYYYMMDD } from "src/utils/datefns";

// TODO: create these datetimefn into datefns.


type MoreysSearchWidgetWildpassesProps = {
    selectedLanguage: string;
    defaultLanguage: string
}

type MoreysSearchWidgetWildpassesState = {
    option: "0" | "1" | "2" | "3" | "4",
}

class MoreysSearchWidgetWildpasses extends React.Component<MoreysSearchWidgetWildpassesProps, MoreysSearchWidgetWildpassesState> {

    state: MoreysSearchWidgetWildpassesState = {
        option: "0",
    }

    get link() {
        if (this.state.option === "0") return "https://moreyspiers.ltibooking.com/purchase-path/product-details/17201";
        if (this.state.option === "1") return "https://moreyspiers.ltibooking.com/purchase-path/product-details/17202";
        if (this.state.option === "2") return "https://moreyspiers.ltibooking.com/purchase-path/product-details/17203";
        if (this.state.option === "3") return "https://moreyspiers.ltibooking.com/categories/wild-passes";
    }

    render() {
        return <>
        <div className={`flex flex-col lg:flex-row gap-4 justify-center items-center p-4 sm:p-6 rounded-b-2xl`}>
            <div className="w-full lg:w-1/2 lg:mr-10">
              <select value={this.state.option} onChange={(e) => this.setState({option: e.target.value as any})} className="w-full rounded-lg bg-[#ED6771] border-[#ED6771] global-bselect caption h-10">
                <option value="0">Wild Pass - 2025</option>
                <option value="1">Senior Wild Pass (65 and Older) - 2025</option>
                <option value="2">Wild Water Park Pass - 2025</option>
                <option value="3">See all options</option>
              </select>
            </div>
            <div className="w-full lg:w-1/4 lg:ml-10">
                <CTAButton link={this.link} className="w-full" roundType="rounded" color="#222" bgcolor='#6CC0BC' hovercolor="#222" hoverbgcolor='#6CC0BC' type="primary" text="SAVE 25%" icon={<Icon className="w-6 h-4" icon="ArrowRight" />} />
            </div>
          </div>
        </>
    }
}

type MoreysSearchWidgetRidesProps = {
    selectedLanguage: string;
    defaultLanguage: string
}

type MoreysSearchWidgetRidesState = {
    option: "0" | "1" | "2"
}

class MoreysSearchWidgetRides extends React.Component<MoreysSearchWidgetRidesProps, MoreysSearchWidgetRidesState> {

    state: MoreysSearchWidgetRidesState = {
        option: "0",
    }

    get link() {
        if (this.state.option === "0") return "https://moreyspiers.ltibooking.com/purchase-path/product-details/16572";
        // if (this.state.option === "1") return "https://moreyspiers.ltibooking.com/purchase-path/product-details/14475";
        if (this.state.option === "2") return "https://moreyspiers.ltibooking.com/categories/ride-or-water-park-admission";
    }

    render() {
        return <>
        <div className={`flex flex-col lg:flex-row gap-4 justify-center items-center p-4 sm:p-6 rounded-b-2xl`}>
            <div className="w-full lg:w-1/2 lg:mr-10 ">
                <select value={this.state.option} onChange={(e) => this.setState({option: e.target.value as any})} className="w-full rounded-lg bg-[#ED6771] border-[#ED6771] global-bselect caption h-10">
                    <option value="0">Amusement Ride Wristband and Water Park Admission Combo</option>
                    {/*<option value="1">Any Day Water Park Admission</option>*/}
                    <option value="2">See all options</option>
                </select>
            </div>
            <div className="w-full lg:w-1/4 lg:ml-10">
                <CTAButton link={this.link} className="w-full" roundType="rounded" color="#222" bgcolor='#6CC0BC' hovercolor="#222" hoverbgcolor='#6CC0BC' type="primary" text="Go" icon={<Icon className="w-6 h-4" icon="ArrowRight" />} />
            </div>
          </div>
        </>
    }
}

type MoreysTicketCardsProps = {
    selectedLanguage: string;
    defaultLanguage: string
}

type MoreysTicketCardsState = {
    option: "0" | "1" | "2" | "3"
}

class MoreysTicketCards extends React.Component<MoreysTicketCardsProps, MoreysTicketCardsState> {

    state: MoreysTicketCardsState = {
        option: "0",
    }

    get link() {
        if (this.state.option === "0") return "https://moreyspiers.ltibooking.com/purchase-path/product-details/17260";
        if (this.state.option === "1") return "https://moreyspiers.ltibooking.com/purchase-path/product-details/17261";
        if (this.state.option === "2") return "https://moreyspiers.ltibooking.com/purchase-path/product-details/17262";
        if (this.state.option === "3") return "https://moreyspiers.ltibooking.com/categories/ticket-cards";
    }

    render() {
        return <>
        <div className={`flex flex-col lg:flex-row gap-4 justify-center items-center p-4 sm:p-6 rounded-b-2xl`}>
            <div className="w-full lg:w-1/2 lg:mr-10">
                <select value={this.state.option} onChange={(e) => this.setState({option: e.target.value as any})} className="w-full rounded-lg bg-[#ED6771] border-[#ED6771] global-bselect caption h-10">
                    <option value="0">82 Ride Ticket Package + 8 Bonus Tickets</option>
                    <option value="1">170 Ride Ticket Package + 15 Bonus Tickets</option>
                    <option value="2">326 Ride Ticket Package + 24 Bonus Tickets</option>
                    <option value="3">See all options</option>
                </select>
            </div>
            <div className="w-full lg:w-1/4 lg:ml-10">
                <CTAButton link={this.link} className="w-full" roundType="rounded" color="#222" bgcolor='#6CC0BC' hovercolor="#222" hoverbgcolor='#6CC0BC' type="primary" text="Go" icon={<Icon className="w-6 h-4" icon="ArrowRight" />} />
            </div>
          </div>
        </>
    }
}

type MoreysStayProps = {
    adults: number | undefined;
    children: number | undefined;
    ages: number[] | undefined;
    startDate: Date | undefined;
    endDate: Date | undefined;
    setStartDate: (date: Date) => void;
    setEndDate: (date: Date) => void;
    setAdults: (adults: number) => void;
    setChilds: (childs: number, ages: number[]) => void;
    minimumDate: Date;
    maximumDate: Date;
    selectedLanguage: string;
    defaultLanguage: string;
}

type MoreysStayState = {
    option: "0" | "1" | "2" | "3" | "4"
}


class MoreysStay extends React.Component<MoreysStayProps, MoreysStayState> {
    /** context: ApplicationContext */
    static contextType = ApplicationContext;
    /** @ts-ignore */
    context!: React.ContextType<typeof ApplicationContext>;

    public state: MoreysStayState = {
        option: "0"
    }


    get link() {
        let linkto = '';
        if (this.state.option === "0") linkto = `https://irm.moreyspiers.com/irmng/?Resort=04&target=availability&arrival=${this.startDate}&departure=${this.endDate}&people1=${this.props.adults || 1}&people2=${this.props.children || 0}&_gl=1*5nutzj*_ga*NTI4NjEyNTY4LjE3MDExNjM3OTQ.*_ga_6RZE5FY6V7*MTcwOTU1NDc5Mi43Mi4xLjE3MDk1NTUwODAuNjAuMC4w`;
        if (this.state.option === "1") linkto = `https://irm.moreyspiers.com/irmng/?resort=03&target=availability&arrival=${this.startDate}&departure=${this.endDate}&people1=${this.props.adults || 1}&people2=${this.props.children || 0}&_gl=1*1f0acp5*_ga*NTI4NjEyNTY4LjE3MDExNjM3OTQ.*_ga_6RZE5FY6V7*MTcwOTU1NDc5Mi43Mi4xLjE3MDk1NTUxMzAuMTAuMC4w`;
        if (this.state.option === "2") linkto = `https://irm.moreyspiers.com/irmng/?resort=05&target=availability&arrival=${this.startDate}&departure=${this.endDate}&people1=${this.props.adults || 1}&people2=${this.props.children || 0}&_gl=1*l56wt2*_ga*NTI4NjEyNTY4LjE3MDExNjM3OTQ.*_ga_6RZE5FY6V7*MTcwOTU1NDc5Mi43Mi4xLjE3MDk1NTUxNTUuNjAuMC4w`;
        if (this.state.option === "3") linkto = `https://irm.moreyspiers.com/irmng/?resort=01&target=availability&arrival=${this.startDate}&departure=${this.endDate}&people1=${this.props.adults || 1}&people2=${this.props.children || 0}&_gl=1*jhsdy6*_ga*NTI4NjEyNTY4LjE3MDExNjM3OTQ.*_ga_6RZE5FY6V7*MTcwOTU1NDc5Mi43Mi4xLjE3MDk1NTUxNjEuNTQuMC4w`;
        if (this.state.option === "4") linkto = `https://www.seapointerealty.com/search-results/?sd=${this.startDateAlt}&ed=${this.endDateAlt}&oc=${(this.props.adults || 1) + (this.props.children || 0)}&sort_by=random`;
        return linkto;
    }

    get startDateAlt() {
        const date = this.props.startDate || (new Date() > this.props.minimumDate ? new Date() : this.props.minimumDate);
        return encodeURIComponent(toFormat(date, 'MM/DD/YYYY'));
    }

    get startDate() {
        const date = this.props.startDate || (new Date() > this.props.minimumDate ? new Date() : this.props.minimumDate);
        return toYYYYMMDD(date);
    }

    get endDateAlt() {
        const date = this.props.endDate || this.props.startDate || (new Date() > this.props.minimumDate ? new Date() : this.props.minimumDate);
        return encodeURIComponent(toFormat(date, 'MM/DD/YYYY'));
    }

    get endDate() {
        const date = this.props.endDate || this.props.startDate || (new Date() > this.props.minimumDate ? new Date() : this.props.minimumDate);
        return toYYYYMMDD(date);
    }

    render() {
        const {startDate, setStartDate, endDate, setEndDate, adults, children, ages, setAdults, setChilds} = this.props;

        return <>
        <div className={`flex flex-col lg:flex-row justify-center items-center gap-4 lg:gap-0 p-4 sm:p-6 rounded-b-2xl`}>
            <div className="w-full lg:w-1/4">
              <select value={this.state.option} onChange={(e) => this.setState({option: e.target.value as any})} className="w-full rounded-lg bg-[#ED6771] border-[#ED6771] global-bselect caption h-10">
                <option value="0">Port Royal Hotel</option>
                <option value="1">Pan American Hotel</option>
                <option value="2">Starlux Boutique Hotel</option>
                <option value="3">Blue Palms Motel</option>
                <option value="4">Seapointe Village Resort</option>
              </select>
            </div>
            <div className="w-full lg:w-1/4 lg:px-2 lg:pr-0">
                <React.Suspense fallback={<div className="w-full h-10 " />}>
                    <DatePickerV2
                        isRange={true}
                        onChange={(dates: Date[])=>{ setEndDate(dates[1]); setStartDate(dates[0]); }}
                        startDate={startDate}
                        startLabel="Check in"
                        endDate={endDate}
                        endLabel="Check out"
                        openToDate={startDate}
                        includeDateIntervals={[{ start: this.props.minimumDate, end: this.props.maximumDate }]}
                        inputBackgroundColor="#ED6771"
                        inputPlaceholderColor="#525258"
                        inputTextColor="#222"
                        inputBorderColor="#ED6771"
                        selectedDayBgColor="#ED6771"
                    />
              </React.Suspense>
            </div>
            <div className="w-full lg:w-1/4 lg:px-2">
                <GuestPickerV2
                    language={this.props.selectedLanguage}
                    withChildAge={true}
                    adults={adults}
                    children={children}
                    ages={ages}
                    setAdults={setAdults}
                    setChilds={setChilds}
                    backgroundColor="#ED6771"
                    borderColor="#ED6771"
                />
            </div>
            <div className="w-full lg:w-1/4">
                { this.context.currency
                    ? <CTAButton roundType="rounded" link={this.link} color="#222" hovercolor="#222" hoverbgcolor='#6CC0BC' bgcolor='#6CC0BC' type="primary" text="Go" icon={<Icon className="w-6 h-4" icon="ArrowRight" />} />
                    : <CTAButton roundType="rounded" link={this.link} color="#222" hovercolor="#222" hoverbgcolor='#6CC0BC' bgcolor='#6CC0BC' type="primary" text="Go" icon={<Icon className="w-6 h-4" icon="ArrowRight" />} />
                }
            </div>
        </div>
        </>
    }
}


type SearchWidgetProps = {
    selectedLanguage: string;
    defaultLanguage: string;
    removeMargin: boolean;
}

type SearchWidgetState = {
    tab: "wildpasses" | "rides" | "tickets" | "stay" | "addons";
    startDate: Date | undefined;
    endDate: Date | undefined;
    adults: number | undefined;
    children: number | undefined;
    ages: number[] | undefined;
}

export default class MoreysSearchWidget extends React.Component<SearchWidgetProps, SearchWidgetState> {

    static minimumDate() {
        const baseDate = new Date();
        const hour = baseDate.getHours();
        const today = DateTime.fromJSDate(baseDate).startOf("day").toJSDate();
        const tomorrow = DateTime.fromJSDate(baseDate).startOf("day").plus({ day: 1 }).startOf("day").toJSDate();
        const minimumStart = hour >= 15 ? tomorrow : today;
        return minimumStart;
    }

    static getEndDate() {
        return DateTime.fromJSDate(MoreysSearchWidget.minimumDate()).plus({day: 1}).toJSDate()
    }

    static maximumDate() {
        const baseDate = new Date();
        const nextYears = DateTime.fromJSDate(baseDate).startOf("day").plus({ year: 2 }).startOf("day").toJSDate();
        return nextYears;
    }

    state: SearchWidgetState = {
        tab: "stay",
        startDate: undefined,
        endDate: undefined,
        adults: 1,
        children: 0,
        ages: undefined,
    }

    setStartDate = (date: Date) => {
        const ts = date.getTime();
        if (this.state.endDate) {
            const ets = this.state.endDate.getTime();
            if (ts > ets) {
                const plus1 = DateTime.fromJSDate(date).plus({day: 1}).toJSDate()
                this.setState({startDate: date, endDate: plus1});
            }
        }
        this.setState({startDate: date});
    }

    setEndDate = (date: Date) => this.setState({endDate: date})
    setAdults = (adults: number) => this.setState({adults})
    setChilds = (childs: number, ages: number[]) => this.setState({children: childs, ages})

    render() {
        return <>
        <div className={`${this.props.removeMargin ? "" : "mt-[-88px]"} flex w-full justify-between lg:px-10 relative z-[2] flex-col`}>
            <div className="w-[95%] sm:max-w-[400px] lg:max-w-6xl justify-center m-auto flex flex-col">
                <SearchWidgetTabs
                    activeTabLineColor="#FFF"
                    activeFocusTextColor="#EFECE2"
                    activeFocusBackgroundColor="#DC3543"
                    desktopActiveTabTextColor="#EFECE2"
                    desktopActiveTabBackgroundColor="#DC3543"
                    desktopInactiveTabTextColor="#EFECE2"
                    desktopInactiveTabBackgroundColor="#DC3543BF"
                    mobileActiveTabBackgroundColor="#DC3543"
                    mobileActiveTabTextColor="#EFECE2"
                    mobileInactiveTabBackgroundColor="#DC3543BF"
                    mobileInactiveTabTextColor="#EFECE2"
                    desktopBackgroundColor="#DC3543"
                    mobileBackgroundColor="#DC3543"
                >
                    <SearchWidgetTabs.Tab
                        label="Wild Passes"
                        icon={<Icon width={26} height={26} icon="RollerCoaster" />}
                        desktopLabelClassname="searchWidgetText text-center" mobileLabelClassname="searchWidgetText"
                    >
                        <MoreysSearchWidgetWildpasses
                            selectedLanguage={this.props.selectedLanguage}
                            defaultLanguage={this.props.defaultLanguage}
                        />
                    </SearchWidgetTabs.Tab>
                    <SearchWidgetTabs.Tab
                        label="Ride and Water Park Admission"
                        icon={<Icon width={26} height={26} icon="Water" />}
                        desktopLabelClassname="searchWidgetText text-center" mobileLabelClassname="searchWidgetText"
                    >
                        <MoreysSearchWidgetRides
                            selectedLanguage={this.props.selectedLanguage}
                            defaultLanguage={this.props.defaultLanguage}
                        />
                    </SearchWidgetTabs.Tab>
                    <SearchWidgetTabs.Tab
                        label="Ticket Cards"
                        icon={<Icon width={26} height={26} icon="TicketStar" />}
                        desktopLabelClassname="searchWidgetText text-center" mobileLabelClassname="searchWidgetText"
                    >
                        <MoreysTicketCards
                            selectedLanguage={this.props.selectedLanguage}
                            defaultLanguage={this.props.defaultLanguage}
                        />
                    </SearchWidgetTabs.Tab>
                    <SearchWidgetTabs.Tab
                        label="Resorts"
                        icon={<Icon width={26} height={26} icon="Bed" />}
                        desktopLabelClassname="searchWidgetText text-center" mobileLabelClassname="searchWidgetText"
                    >
                        <MoreysStay
                            startDate={this.state.startDate}
                            endDate={this.state.endDate}
                            setStartDate={this.setStartDate}
                            setEndDate={this.setEndDate}
                            adults={this.state.adults}
                            setAdults={this.setAdults}
                            children={this.state.children}
                            setChilds={this.setChilds}
                            ages={this.state.ages}
                            minimumDate={MoreysSearchWidget.minimumDate()}
                            maximumDate={MoreysSearchWidget.maximumDate()}
                            selectedLanguage={this.props.selectedLanguage}
                            defaultLanguage={this.props.defaultLanguage}
                        />
                    </SearchWidgetTabs.Tab>
                </SearchWidgetTabs>
            </div>
        </div>
        </>
    }

}